<div class="card shadow-none border-0" [ngStyle]="{ visibility: hidden ? 'hidden' : 'visible' }">
  <div class="card-body pt-2">
    <div class="row mt-2 mb-4">
      <div class="col-5">
        <span class="nav-font18 nav-secondary font-weight-bold">Add Note for {{partnerName}}</span>
      </div>
      <div class="col d-flex align-items-center justify-content-end">
        <i class="fas fa-close cursor-pointer grey4" (click)="closeModal()"></i>
      </div>
    </div>

    <div class="form-entry">
      <div class="row mb-3">
        <div class="col-1 grey5 d-flex align-items-center"><label class="">Subject</label>
        </div>
        <div class="col-6 nav-black2 pl-0">
          <input type="text" [(ngModel)]="subject" placeholder="OOO Instructions"
          name="subject" class="form-control form-control-sm form-control-nav w-50">
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-1 grey5 d-flex align-items-center"><label class="">Title</label>
        </div>
        <div class="col-6 nav-black2 pl-0">
          <input type="text" [(ngModel)]="title" placeholder="Type note title"
          name="title" class="form-control form-control-sm form-control-nav w-50">
        </div>
      </div>
      <div class="row mb-3">
        <div class="col grey5 d-flex align-items-center">
          <i class="fak fa-info mr-2 grey4"></i>
          To edit or delete this note, go to the Notes menu.
        </div>
      </div>
      
      
      <div class="ckeditor position-relative">
        <or-wysiwyg (messageEvent)="wysiwygUpdate($event)" [config]="editorConfig"  [data]="newNote.message"></or-wysiwyg>
      </div>      
  
      <div class="or-checkbox d-flex justify-content-start align-items-center px-1">
        <span container="body">
          <input type="checkbox" id="addToAllVendors" [(ngModel)]="addToAllVendors">
          <label for="addToAllVendors" class=""></label>
        </span>
        <span class="grey5 nav-font14 pl-4">Add this note for all vendors.</span>
      </div>
  
    </div>

    <div class="d-flex align-items-center justify-content-end">
      <span type="button" class="btn btn-sm nav-btn-primary shadow-none font-weight-bold"
        (click)="cancel()">Cancel</span>
      <span type="button" class="btn ml-2 btn-sm nav-btn-accent shadow-none font-weight-bold"
        (click)="save()">Save</span>
    </div>


  </div>
</div>

